import React from 'react';
import { stylesheet } from 'typestyle';
import { Blue100, Button, Gray100, typeBase14RegularProperties, typeCompact14MediumProperties } from '@traceair/tds';
import { GoogleDriveIcon } from '../../../../../images/components/GoogleDriveIcon';

const css = stylesheet({
  text: {
    marginBottom: 16,
  },
  heading: {
    margin: '0 0 6px',
    ...typeCompact14MediumProperties,
  },
  description: {
    margin: 0,
    ...typeBase14RegularProperties,
    color: Gray100,
  },
  button: {
    maxWidth: 230,
  },
});

interface Props {
  altaTopoExchangeFolder: string;
}

export const MissionWindowAltaTopo = ({ altaTopoExchangeFolder }: Props) => {
  const handleClick = () => {
    window.open(altaTopoExchangeFolder);
  };

  return (
    <div>
      <div className={css.text}>
        <div className={css.heading}>ALTA/TOPO project files</div>
        <div className={css.description}>
          Review the initial PPLS files before the flight. <br />
          Upload your ALTA/TOPO files there.
        </div>
      </div>

      <div className={css.button}>
        <Button
          style="secondary"
          size="xs"
          fullWidth
          icon={<GoogleDriveIcon color={Blue100} />}
          text="Go to Google Drive"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};
